import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (consumidores/specs antigos importavam estes nomes). */
export type CertidaoJubilamentoMedicoJob = ReportJob;
export type CertidaoJubilamentoMedicoJobStatus = JobStatus;

@Injectable({ providedIn: 'root' })
export class CertidaoJubilamentoMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-jubilamento-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.certidaoJubilamentoMedico;
}
